import {Link} from 'react-router-dom'
import { useContext } from "react";
import { AuthContext } from "../../context/authContext";

const MainLayout = () => {

  const { currentUser } : any = useContext(AuthContext);
  
  return (
    <footer className="footer">
      <Footer />
    </div>
  );
};
